'use client';

import { Fraunces, Inter, IBM_Plex_Mono } from 'next/font/google';
import { get } from 'lodash';
import TourismExplorePage from './Tourismexplorepage';

// Display face — dùng có tiết chế cho tiêu đề (Fraunces).
const fraunces = Fraunces({
  subsets: ['latin', 'vietnamese'],
  weight: ['500', '600'],
  variable: '--font-display',
});

// Body face cho phần mô tả, UI (Inter).
const inter = Inter({
  subsets: ['latin', 'vietnamese'],
  variable: '--font-body',
});

// Utility face cho nhãn nhỏ, số liệu, breadcrumb (IBM Plex Mono).
const plexMono = IBM_Plex_Mono({
  subsets: ['latin'],
  weight: ['400', '500'],
  variable: '--font-mono',
});

export const metadata = {
  title: 'Khám phá Bằng Lang | Du lịch',
  description: 'Khám phá cao nguyên đá, ruộng bậc thang và văn hóa thổ cẩm của người Dao, Lô Lô tại Bằng Lang.',
};

// Trang này lấy dữ liệu ở server để tải nhanh và tốt cho SEO; phần tương tác
// (lọc theo tag, xem thêm, hiệu ứng cuộn) nằm ở TourismExplorePage (client).
export default async function PromoteTourismPage({ tourismData }) {
  const data = get(tourismData, 'results', []);
  return (
    <div className={`${fraunces.variable} ${inter.variable} ${plexMono.variable} font-body`}>
      <TourismExplorePage tourismData={data} websiteCode={null} />
    </div>
  );
}
